export default {
	inquiryFilterStat: '/email/inquiry/statistics', // 询盘过滤统计
	filterRuleList: '/inquiry/filter/list', // 过滤规则列表
	addFilterRule: '/inquiry/filter/addorupdate', // 新增过滤规则
	deleteFilterRule: '/inquiry/filter/delete/{id}/{type}', // 移除过滤规则
};
